/**
 * Megamenu types matching i18n structure (megamenu.navigationItems).
 * Data lives in i18n/translations/{locale}/megamenu.ts.
 * Data is in i18n: use tm('megamenu.navigationItems') to read nav items.
 */

export interface MegamenuLink {
  label: string
  href?: string
}

export interface MegamenuSubSection {
  title: string
  items: MegamenuLink[]
}

export interface MegamenuSection {
  title: string
  items?: MegamenuLink[]
  subSections?: MegamenuSubSection[]
}

export interface MegamenuNavItem {
  path: string
  label: string
  showOnSub?: boolean
  /** When true, sections are shown as accordion in place instead of opening a separate panel */
  expandInPanel?: boolean
  primaryLink?: { label: string; href: string }
  sections?: MegamenuSection[]
  items?: MegamenuLink[]
}

export type MegamenuNavigationItems = MegamenuNavItem[]

/** Path for Sales in Experiences dropdown. Use localePath() in components. */
export const megamenuSalesPath = '/search?promo=sales'
